// libs
import React, {useEffect, useState} from 'react'
import { ToastContainer, toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
// components 
// ... 
// config & functions 
import ajaxCall from '../utils/ajaxcall'

function ConfirmationBox({loadapidata, apidataparams, setshowdeletemodalbox, url, params, token}) {

    const [IsDelete, setIsDelete] = useState(false);
    const [Show, setShow] = useState(false);

    const hideModal = () => {
		setShow(false);
        setshowdeletemodalbox(false); // make it 0 and remove component from parent div
	}

    const initDeleteRecord = async () => {
        setIsDelete(true);
        const apiCall = await ajaxCall.deleteCall(url, params, token);
        if(apiCall) {
            setIsDelete(false);
            toast.info('Record deleted successfully');
            loadapidata(apidataparams); // refresh list page
            setTimeout(() => {
                hideModal();
            }, 1000);
        } else {
            setIsDelete(false);
            toast.error('Something went wrong. Please try again');
        }
    }

    useEffect(() => {
        async function loadComponent() {
            setShow(true);
        }
        loadComponent();
    });

    return (
        <Modal show={Show}>
            <Modal.Header>
                <Modal.Title>Confirmation Box</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Are you sure you want to delete this record?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="fs-14rem" onClick={hideModal}>Close</Button>
                <Button variant="primary" className="fs-14rem" disabled={IsDelete} onClick={() => initDeleteRecord()}>{(IsDelete)?'Deleting...':'Delete'}</Button>
            </Modal.Footer>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
		</Modal>
    )
}
export default ConfirmationBox;
